//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import UploadFile from '../../../../shared-components/upload/UploadFile';
import InputDatepicker from '../../../../shared-components/datepicker/InputDatepicker';

import { basePath } from '../../../../common/resources/importacoes';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'SellInSideColumn',
  props: {
    exibeCancelar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataInicio: '',
      dataFim: '',
    };
  },
  computed: {
    ...mapGetters('importacao', {
      tiposImportacao: 'getTiposImportacao',
    }),
    ...generateComputed('Sellin', [
      'canImport',
      'canExport',
    ]),
    showImport() {
      if (this.dataInicio === '' || this.dataFim === '') {
        return false;
      }
      const inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      const fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    },
    tipoImportacao() {
      return this.tiposImportacao.find(el => el.nome === 'importacao_sellin');
    },
    uploadFileDropzoneId() {
      return `myVueDropzone${(Math.random() * Math.random() * 100).toString().replace('.', '')}`;
    },
    importUrl() {
      return `${basePath}/importacao`;
    },

  },
  components: {
    UploadFile,
    InputDatepicker,
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      const parametros = { data_inicio: this.dataInicio, data_fim: this.dataFim };

      formData.append('id_tipo_importacao', 8);
      formData.append('parametros', JSON.stringify(parametros));
    },
    cancelarImportacao() {
      this.$emit('IMPORTACAO_LATERACAO_CANCELAR');
    },
    dataInicialFormatada(dataInicial) {
      this.dataInicio = dataInicial;
    },

    dataFimFormatada(dataFim) {
      this.dataFim = dataFim;
    },
    dataFimMoment() {
      // this.dataFim = dataFim;
    },
    uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
    },
    validarDatas() {
      if (this.dataInicio === '' || this.dataFim === '') {
        return false;
      }
      const inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      const fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-in/SellInLateral.vue?vue&type=script&lang=js&